import { Component, Input, OnChanges, OnInit } from '@angular/core';

import {
  InternalStatus,
  WasteProfile,
  WasteProfileAdminCard,
} from '@digital-platform/waste-profiles/domain';

@Component({
  selector: 'digital-platform-waste-profile-admin-card',
  templateUrl: './waste-profile-admin-card.component.html',
  styleUrls: ['./waste-profile-admin-card.component.scss'],
})
export class WasteProfileAdminCardComponent implements OnInit, OnChanges {
  @Input() wasteProfile: WasteProfileAdminCard | WasteProfile;
  public dateFormat = 'LLL.dd.yy';
  public showReview = false;
  public showViewProfile = false;

  public showApprovedDate = false;
  ngOnInit(): void {
    if (this.wasteProfile?.internalStatus === InternalStatus.FINAL_APPROVAL) {
      this.showApprovedDate = true;
    }
  }
  public ngOnChanges(): void {
    if (this.wasteProfile) {
      const { internalStatus } = this.wasteProfile;
      this.showReview =
        internalStatus === InternalStatus.COORDINATOR_APPROVED ||
        internalStatus === InternalStatus.ANALYST_REVIEW;
      this.showViewProfile =
        internalStatus === InternalStatus.FINAL_APPROVAL ||
        internalStatus === InternalStatus.ANALYST_APPROVED;
    }
  }
}
